/**
 * Client-side UUID v4 generation.
 *
 * The POS generates entity ids (tabs, tab items, sales) on the client so that
 * offline-created records are immediately referenceable (add items to a tab that
 * hasn't reached the server yet) and mutation replays are idempotent.
 */
export const generateUuid = (): string => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  // Fallback for older WebViews without crypto.randomUUID
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};
